import { roles, rolesEnum } from "helpers/enums/roles";
export type RolesModel = {
    isRoot: boolean;
    isAdmin: boolean;
    isDriver: boolean;
    isGuest: boolean;
    isTechSupport: boolean;
    isDiagnostics: boolean;
    isTruckingOrganizationAdmin: boolean;
    isTruckingOrganizationManager: boolean;
    isTruckingOrganizationHeadLogist: boolean;
    isTruckingOrganizationOperator: boolean;
    isTruckingOrganizationViewer: boolean;
    isTruckingOrganizationDispatcher: boolean;
    isTruckingOrganizationExtendedViewer: boolean;
    isCargoOwnerAdmin: boolean;
    isCargoOwnerManager: boolean;
    isForwarder: boolean; // TODO check this role, is outdated
    isForwarderAdmin: boolean;
    isForwarderManager: boolean;
    isDataAdmin: boolean;
    isIntegrationAccount: boolean;
    isIntegrationManager: boolean;
    isAccountManager: boolean;
    isWaybillIntegrationAccount: boolean;
    isManagementSystem: boolean;
};

/** Match TruckingOrganizationLogists, including the backend's Root bypass. */
export const isTruckingOrganizationLogist = (roles?: RolesModel | null): boolean =>
    Boolean(
        roles &&
            (roles.isRoot ||
                roles.isTruckingOrganizationAdmin ||
                roles.isTruckingOrganizationManager ||
                roles.isTruckingOrganizationHeadLogist),
    );

export function createRolesObject(rolesArray: string[]) {
    return Object.values(rolesEnum).reduce((acc, key) => {
        const label = roles.find((item) => item.value === rolesEnum[key])!.label;
        return { ...acc, [`is${key}`]: rolesArray.includes(label) };
    }, {} as RolesModel);
}

export function isOnlyInRole(roles: RolesModel, roleName: keyof RolesModel) {
    let allRolesAreFalse = true;
    for (const key in roles) {
        if (roleName !== key) {
            allRolesAreFalse = allRolesAreFalse && !roles[key as keyof RolesModel];
        }
    }
    return roles[roleName] && allRolesAreFalse;
}

export function noRolesOtherThan(roles: RolesModel, rolesToCheck: Array<keyof RolesModel>) {
    let result = false;
    for (const key in roles) {
        const value = roles[key as keyof RolesModel];
        if (rolesToCheck.includes(key as keyof RolesModel)) {
            if (value) {
                result = true;
            }
        } else {
            if (value) {
                return false;
            }
        }
    }
    return result;
}
